import { fetchToken, fetchTokenFile } from '../helpers/fetch';
import { const_routes } from '../helpers/const_routes';
import { types } from '../types/types';
import { startLogout } from './authActions';
import Swal from 'sweetalert2';
import { t } from 'i18next';

const handleAuthErrors = (dispatch, body) => {
  if (!body || body.ok !== false) return false;
  if (body.code === 'bak-aut-tok-inv-001') {
    Swal.fire(t('titles.error'), t('alerts.validation.bak-aut-tok-inv-001'), 'error');
    dispatch(startLogout());
    return true;
  }
  if (body.code === 'bak-aut-tok-inv-002' || body.code === 'bak-aut-tok-001' || body.code === 'bak-aut-tok-002') {
    Swal.fire(t('titles.error'), t('api.token.timed_out'), 'error');
    dispatch(startLogout());
    return true;
  }
  if (body.code === 'bak-error-001') {
    Swal.fire(
      t('titles.error'),
      `${t('alerts.validation.bak-error-001')} - ${body.method || ''}`,
      'error'
    );
    return true;
  }
  return false;
};

const callJson = async (endpoint, data, method = 'GET') => {
  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_SPECIALIST_GUIDES}`,
    endpoint,
    data,
    method
  );
  return resp.json();
};

export const startLoadingSpecialistGuideOptions = () => {
  return async (dispatch) => {
    try {
      const body = await callJson('options');
      if (body.ok) {
        dispatch({ type: types.SPECIALIST_GUIDE_SET_OPTIONS, payload: body.options || {} });
      } else {
        handleAuthErrors(dispatch, body);
      }
      return body;
    } catch (error) {
      return { ok: false, msg: String(error) };
    }
  };
};

export const startLoadingSpecialistGuides = () => {
  return async (dispatch) => {
    dispatch({ type: types.SPECIALIST_GUIDE_SET_LOADING, payload: true });
    try {
      const body = await callJson('get');
      if (body.ok) {
        dispatch({ type: types.SPECIALIST_GUIDE_SET_LIST, payload: body.specialistGuides || [] });
      } else {
        dispatch({ type: types.SPECIALIST_GUIDE_SET_LOADING, payload: false });
        handleAuthErrors(dispatch, body);
      }
      return body;
    } catch (error) {
      dispatch({ type: types.SPECIALIST_GUIDE_SET_LOADING, payload: false });
      return { ok: false, msg: String(error) };
    }
  };
};

export const startAddSpecialistGuides = (formData) => {
  return async (dispatch) => {
    try {
      const resp = await fetchTokenFile(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_GUIDES}`,
        'add',
        formData,
        'POST'
      );
      const body = await resp.json();
      if (body.ok) {
        Swal.fire(t('titles.success', { defaultValue: 'Listo' }), t('specialistGuides.saved'), 'success');
        await dispatch(startLoadingSpecialistGuides());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      Swal.fire(t('titles.error'), String(error), 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

export const startUpdateSpecialistGuide = (id, formData) => {
  return async (dispatch) => {
    try {
      const resp = await fetchTokenFile(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_GUIDES}`,
        `update/${id}`,
        formData,
        'PUT'
      );
      const body = await resp.json();
      if (body.ok) {
        Swal.fire(t('titles.success', { defaultValue: 'Listo' }), t('specialistGuides.saved'), 'success');
        await dispatch(startLoadingSpecialistGuides());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      Swal.fire(t('titles.error'), String(error), 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

export const startDeleteSpecialistGuide = (id) => {
  return async (dispatch) => {
    try {
      const body = await callJson(`delete/${id}`, {}, 'DELETE');
      if (body.ok) {
        await dispatch(startLoadingSpecialistGuides());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      return { ok: false, msg: String(error) };
    }
  };
};

export const startDownloadSpecialistGuide = (id, filename) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_GUIDES}`,
        `download/${id}`
      );
      const contentType = resp.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const body = await resp.json();
        if (!handleAuthErrors(dispatch, body) && body.msg) {
          Swal.fire(t('titles.error'), body.msg, 'error');
        }
        return body;
      }
      if (!resp.ok) {
        Swal.fire(t('titles.error'), t('specialistGuides.downloadError'), 'error');
        return { ok: false };
      }
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'guia';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { ok: true };
    } catch (error) {
      Swal.fire(t('titles.error'), String(error), 'error');
      return { ok: false, msg: String(error) };
    }
  };
};
